/* eslint-disable consistent-return */

/* eslint-disable babel/no-unused-expressions */

/**
 * Does not call `ourHandler` if the event's `defaultPrevented` property is `true`.
 * @param theirHandler - The handler to always be called.
 * @param ourHandler - The handler to only be called when the event's `defaultPrevented` property is `false`.
 */
function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    theirHandler === null || theirHandler === void 0 ? void 0 : theirHandler(event);

    if (!event.defaultPrevented) {
      return ourHandler === null || ourHandler === void 0 ? void 0 : ourHandler(event);
    }
  };
}

export { wrapEvent as default };
